// Custom Colors = [RLGold,RLWhite,RLViolet]
/* social link custom colors {
   circle colors: [RLWhite]
   icon colors: [RLRed]
}*/
// if button is colored you must add a fontColor
// to change border color of a colored button add color to additionalstyles
export const PROFILE = {
    title: {
        title: 'ItsCakess',
        color: 'RLWhite',
        font: '',
    },
    TRCLogo: 'white',
    profilePic:
        'https://res.cloudinary.com/rightlink/image/upload/v1691082830/ItsCakess/IMG_8894_mi3gxw.jpg',
    background: {
        image: false,
        imageLink: '',
        color: 'background-image: linear-gradient(to bottom, #000000, #000000, #000000, #000000, #000000, #000000, #000000, #000000, #000000, #000000, #000000, #000000);',
        logoLink:
            'https://res.cloudinary.com/rightlink/image/upload/v1597512951/ItsCakess/NewLogo_g7zrqo.png',
    },
};
export const SOCIAL_LINKS = {
    position: 'top',
    group: [
        {
            name: 'Instagram',
            iconName: 'instagram',
            link: 'https://www.instagram.com/itscakess',
            color: 'RLViolet',
            inverted: false,
            secondaryColor: '',
            surrounded: 'circular',
            surroundedInColor: false,
        },
        {
            name: 'Facebook',
            iconName: 'facebook',
            link: 'https://www.facebook.com/ItsCakess/',
            color: 'RLViolet',
            inverted: false,
            secondaryColor: '',
            surrounded: 'circular',
            surroundedInColor: false,
        },
        {
            name: 'Twitter',
            iconName: 'twitter',
            link: 'https://twitter.com/itscakess',
            color: 'RLViolet',
            inverted: false,
            surrounded: 'circular',
            secondaryColor: '',
            surroundedInColor: false,
        },
        {
            name: 'Soundcloud',
            iconName: 'soundcloud',
            link: 'https://soundcloud.com/itscakess',
            color: 'RLViolet',
            inverted: false,
            secondaryColor: '',
            surrounded: 'circular',
            surroundedInColor: false,
        },
    ],
};

// featuredTimerDate formats inclued '2020-02-01T01:02:03' or milliseconds e.g 1580518923000 - documentation here https://github.com/ndresx/react-countdown
// for media as links you must set type as 'item' and mainMedia.type as either 'still, mp4, or other(not implemented yet)'
// using a new Link_group setup

export const LINK_GROUPS = [
    {
        groupName: '',
        groupColor: 'orange',
        groupFont: '',
        group: [
            {
                name: 'Feel Today',
                link: '',
                linkSpaced: true,
                type: 'item',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'video',
                    link: 'https://youtu.be/qBA-Ucn2ZUk',
                    mediaText: '',
                    videoPoster: '',
                },
                additionalLinks: [],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
            {
                name: 'Keep Up - Live',
                link: '',
                linkSpaced: true,
                type: 'item',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'video',
                    link: 'https://youtu.be/Hf3J-jHVlow',
                    mediaText: '',
                    videoPoster: '',
                },
                additionalLinks: [],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
            {
                name: 'Stream ItsCakess',
                link: '',
                linkSpaced: true,
                type: 'internal',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'still',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1597512951/ItsCakess/NewLogo_g7zrqo.png',
                    mediaText: 'Stream ItsCakess Now',
                    videoPoster: '',
                },
                additionalLinks: [
                    {
                        name: 'Tidal',
                        link: 'https://listen.tidal.com/artist/19820529',
                    },
                    {
                        name: 'Spotify',
                        link: 'https://open.spotify.com/artist/1ctP5DFsr3daxwTSwWUmWg',
                    },
                    {
                        name: 'Apple Music',
                        link: 'https://music.apple.com/us/artist/itscakess/1516044629',
                    },
                    {
                        name: 'Youtube',
                        link: 'https://www.youtube.com/channel/UC9cVQA74sXyS7qwRfTwT2xw',
                    },
                    {
                        name: 'iHeart Music',
                        link: 'https://www.iheart.com/artist/lgunna-itscakess-34170374/',
                    },
                ],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
            {
                name: 'Radio Music - Album',
                link: '',
                linkSpaced: true,
                type: 'internal',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'still',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
                    mediaText: 'Stream Radio Music',
                    videoPoster: '',
                },
                additionalLinks: [
                    {
                        name: 'Tidal',
                        link: 'https://tidal.com/album/304756709',
                    },
                    {
                        name: 'Spotify',
                        link: 'https://open.spotify.com/album/4ZRz94npiz9cbRndZq5kCI',
                    },
                    {
                        name: 'Apple Music',
                        link: 'https://music.apple.com/us/album/radio-music/1697397694',
                    },
                    {
                        name: 'Youtube',
                        link: 'https://youtube.com/playlist?list=OLAK5uy_mBJ0HmJJzHZk1EjGT_KvYAwsOtvAOp-Ko',
                    },
                ],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
            {
                name: 'Keep Up - Single',
                link: '',
                linkSpaced: true,
                type: 'internal',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {
                    type: 'still',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
                    mediaText: 'Stream Keep Up',
                    videoPoster: '',
                },
                additionalLinks: [
                    {
                        name: 'Tidal',
                        link: 'https://tidal.com/track/147896939',
                    },
                    {
                        name: 'Spotify',
                        link: 'https://open.spotify.com/album/0oR1rFbI6JGwPdKFDQEy1T?si=KCQ2VGXDRviEgfH8eFyCAw',
                    },
                    {
                        name: 'Apple Music',
                        link: 'https://music.apple.com/us/album/keep-up/1572516246?i=1572516248',
                    },
                    {
                        name: 'Youtube',
                        link: 'https://youtu.be/87kS-vGMao4',
                    },
                ],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
            {
                name: 'Hot Water - Single',
                link: '',
                linkSpaced: true,
                type: 'internal',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: 'bannerRLViolet',
                pinned: true,
                mainMedia: {
                    type: 'still',
                    link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
                    mediaText: 'Stream Hot Water',
                    videoPoster: '',
                },
                additionalLinks: [
                    {
                        name: 'Tidal',
                        link: 'https://tidal.com/album/297951861',
                    },
                    {
                        name: 'Spotify',
                        link: 'https://open.spotify.com/album/3UGaxibOsam8ei5De0NX77?si=gI8Q2d1bQFaEysuwk0Jt6A&dl_branch=1',
                    },
                    {
                        name: 'Apple Music',
                        link: 'https://music.apple.com/us/album/hot-water-single/1690713823',
                    },
                    {
                        name: 'Youtube',
                        link: 'https://youtu.be/YznrYvX0RYY',
                    },
                ],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
            {
                name: 'ItsCakess.com',
                link: 'https://www.itscakess.com',
                linkSpaced: true,
                type: 'external',
                typeAction: '',
                internal: false,
                featured: false,
                featuredText: '',
                featuredTimerDate: '',
                featuredTimerText: '',
                featuredColor: '',
                featuredAltStyle: '',
                pinned: true,
                mainMedia: {},
                additionalLinks: [],
                color: '',
                colorOveride: 'RLViolet',
                fontColor: '',
                colored: false,
                buttonColor: '',
                bannerSide: 'left',
                additionalStyle: 'longText',
                modalAlternativeText: {
                    removed: true,
                    text: '',
                },
            },
        ],
    },
];

export const ARCHIVE = [
    {
        name: 'Hot Water - Single',
        link: '',
        linkSpaced: true,
        type: 'internal',
        typeAction: '',
        internal: false,
        featured: true,
        featuredText: 'New',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: 'bannerRLViolet',
        pinned: true,
        mainMedia: {
            type: 'still',
            link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
            mediaText: 'Stream Hot Water',
            videoPoster: '',
        },
        additionalLinks: [
            {
                name: 'Tidal',
                link: 'https://tidal.com/track/191484787',
            },
            {
                name: 'Spotify',
                link: 'https://open.spotify.com/album/3UGaxibOsam8ei5De0NX77?si=gI8Q2d1bQFaEysuwk0Jt6A&dl_branch=1',
            },
            {
                name: 'Apple Music',
                link: 'https://music.apple.com/us/album/hot-water/1577268254?i=1577268255',
            },
            {
                name: 'Youtube',
                link: 'https://youtu.be/YznrYvX0RYY',
            },
        ],
        color: '',
        colorOveride: 'RLViolet',
        fontColor: '',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'Keep It Going - Single',
        link: '',
        linkSpaced: true,
        type: 'internal',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {
            type: 'still',
            link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
            mediaText: 'Stream Keep It Going',
            videoPoster: '',
        },
        additionalLinks: [
            {
                name: 'Tidal',
                link: 'https://tidal.com/album/156727836',
            },
            {
                name: 'Spotify',
                link: 'https://open.spotify.com/album/7CIDPvHQo4X53tnt3dM7Lp?si=e5j06vGtQIOmKsHx4othCw',
            },
            {
                name: 'Apple Music',
                link: 'https://music.apple.com/us/album/keep-it-going-single/1535053547',
            },
            {
                name: 'Youtube',
                link: 'https://youtu.be/pnV87RtOdW8',
            },
        ],
        color: '',
        colorOveride: 'RLViolet',
        fontColor: '',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'What We Do - Single',
        link: '',
        linkSpaced: true,
        type: 'internal',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {
            type: 'still',
            link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
            mediaText: 'Stream What We Do Now',
            videoPoster: '',
        },
        additionalLinks: [
            {
                name: 'Tidal',
                link: 'https://tidal.com/track/153294701',
            },
            {
                name: 'Spotify',
                link: 'https://open.spotify.com/album/2L7o23kKcxhf7Bwbp9FmuW?si=zWu7cx-yQOmbsOt7siSLiA',
            },
            {
                name: 'Apple Music',
                link: 'https://music.apple.com/us/album/what-we-do-single/1529559638',
            },
            {
                name: 'Youtube',
                link: 'https://youtu.be/Myz7O9EW18I',
            },
        ],
        color: '',
        colorOveride: 'RLViolet',
        fontColor: '',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'Touch - Single',
        link: '',
        linkSpaced: true,
        type: 'internal',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {
            type: 'still',
            link: 'https://res.cloudinary.com/rightlink/image/upload/v1597533035/ItsCakess/LogoBlackGlossy_fdr3u7.png',
            mediaText: 'Stream Touch Now',
            videoPoster: '',
        },
        additionalLinks: [
            {
                name: 'Tidal',
                link: 'https://tidal.com/track/134167018',
            },
            {
                name: 'Spotify',
                link: 'https://open.spotify.com/album/0w8mZfnXCwrVfaajs5J27t?highlight=spotify:track:30ZjpPqcJBgdhbpW8DSJpY',
            },
            {
                name: 'Apple Music',
                link: 'https://music.apple.com/us/album/touch-single/1502650549',
            },
            {
                name: 'Youtube',
                link: 'https://youtu.be/Ae7l0RO_WkE',
            },
        ],
        color: '',
        colorOveride: 'RLViolet',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'Shop - Gold Decisions',
        link: 'https://www.shopgolddecisions.com',
        linkSpaced: true,
        type: 'external',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {},
        additionalLinks: [],
        color: '',
        colorOveride: 'RLViolet',
        fontColor: '',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'Keep Up - Single',
        link: '',
        linkSpaced: true,
        type: 'internal',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {
            type: 'still',
            link: 'https://res.cloudinary.com/rightlink/image/upload/v1597512951/ItsCakess/NewLogo_g7zrqo.png',
            mediaText: 'Stream Keep Up Now',
            videoPoster: '',
        },
        additionalLinks: [
            {
                name: 'Tidal',
                link: 'https://tidal.com/track/147896939',
            },
            {
                name: 'Spotify',
                link: 'https://open.spotify.com/album/0oR1rFbI6JGwPdKFDQEy1T?si=KCQ2VGXDRviEgfH8eFyCAw',
            },
            {
                name: 'Apple Music',
                link: 'https://music.apple.com/us/album/keep-up-single/id1522615990',
            },
            {
                name: 'Youtube',
                link: 'https://youtu.be/87kS-vGMao4',
            },
        ],
        color: '',
        colorOveride: 'RLGold',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'Pre-order Keep It Going',
        link: 'https://distrokid.com/hyperfollow/itscakess/keep-it-going',
        linkSpaced: true,
        type: 'external',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {},
        additionalLinks: [],
        color: '',
        colorOveride: 'RLGold',
        fontColor: 'RLRed',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText RLGold',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
    {
        name: 'Crosses',
        link: '',
        linkSpaced: true,
        type: 'item',
        typeAction: '',
        internal: false,
        featured: false,
        featuredText: '',
        featuredTimerDate: '',
        featuredTimerText: '',
        featuredColor: '',
        featuredAltStyle: '',
        pinned: true,
        mainMedia: {
            type: 'video',
            link: 'https://youtu.be/KPalbG29bUw',
            mediaText: '',
            videoPoster: '',
        },
        additionalLinks: [],
        color: '',
        colorOveride: 'RLGold',
        fontColor: '',
        colored: false,
        buttonColor: '',
        bannerSide: 'left',
        additionalStyle: 'longText',
        modalAlternativeText: {
            removed: true,
            text: '',
        },
    },
];
